import React from "react";
import UsersThatHaveCompleteLesson from "./usersThatHaveTheCompleteLesson";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import UsersWithHighestCourseCompletion from "./usersThatHaveCompletedCourse";
import UserTrainings from "./userTrainings";
import SubcontractorCompletedTraingings from "./subContractorCompletedTrainings";
import NotCompletedTrainingUSers from "./notCompletedTrainingUSers";
import { REPORTS_ANALYTICS_LMS_DASHBOARD_DETAILS } from "../../../../constant/routeContant";

const Items = (props) => {
  const TRAINING_WITH_LOWEST_PARTICIPATION_REPORT_DETAILS = 10;

  const isListPage =
    props?.page === "usersWithMostIncompletedTraining" ||
    props?.page === "usersWithHighestCompletedTraining" ||
    props?.page === "TrainingWithLowestParticipation";
  const backTypeselectdata =
    props?.page === "TrainingWithLowestParticipation"
      ? (props?.typeselectdata ?? [])
      : [];

  const backApiData =
    props?.page === "TrainingWithLowestParticipation" && props?.apiData
      ? {
          ...props.apiData,
          reportDetails:
            props.apiData.reportDetails ??
            TRAINING_WITH_LOWEST_PARTICIPATION_REPORT_DETAILS,
        }
      : props?.apiData;
  const dataBack = {
    title: "Back",
    route:
      props?.location?.state?.courseDetailBackPath || isListPage
        ? REPORTS_ANALYTICS_LMS_DASHBOARD_DETAILS
        : -1,
    state: {
      backpage: "backpage",
      ...props?.location?.state,
      page: props?.location?.state?.page,
      typeselectdata: backTypeselectdata,
      apiData: backApiData,
    },
  };
  return (
    <div>
      <div onClick={() => props?.handleClear()}>
        <BackBtn dataBack={dataBack} />
      </div>
      {props.page === "UsersThatHaveCompleteLesson" ? (
        <UsersThatHaveCompleteLesson
          getMoretDetails={props.getMoretDetails}
          getLmsDashboardReportDetails={
            props.getLmsDashboardReportDetails?.data
          }
          apiData={props.apiData}
          getAssignLessonUserListData={props.lessonUserAssignListData}
          handleClear={props?.handleClear}
        />
      ) : props.page === "TrainingWithLowestParticipation" ? (
        <NotCompletedTrainingUSers
          getMoretDetails={props.getMoretDetails}
          getLmsDashboardReportDetails={
            props.getLmsDashboardReportDetails?.data
          }
          apiData={props.apiData}
          coursesUserAssignListData={props.coursesUserAssignListData}
          getAssignLessonUserListData={props.lessonUserAssignListData}
          location={props?.location}
          handleClear={props?.handleClear}
          getScheduleInstructorDetailsData={
            props?.getScheduleInstructorDetailsData
          }
          page={props.page}
        />
      ) : props.page === "UsersWithHighestCourseCompletion" ? (
        <UsersWithHighestCourseCompletion
          getMoretDetails={props.getMoretDetails}
          getLmsDashboardReportDetails={
            props.getLmsDashboardReportDetails?.data
          }
          apiData={props.apiData}
          coursesUserAssignListData={props.coursesUserAssignListData}
          handleClear={props?.handleClear}
          page={props.page}
        />
      ) : props.page === "usersWithHighestCompletedTraining" ||
        props.page === "usersWithMostIncompletedTraining" ? (
        <UserTrainings
          getMoretDetails={props.getMoretDetails}
          getLmsDashboardReportDetails={
            props.getLmsDashboardReportDetails?.data
          }
          apiData={props.apiData}
          coursesUserListData={props.coursesUserListData}
          lessionUserListData={props.lessionUserListData}
          getToolBoxTalkListResult={props.getToolBoxTalkListResult}
          page={props.page}
          userTRainingLoadin={props?.userTRainingLoadin}
          handleClear={props?.handleClear}
          getScheduleInstructorDetailsData={
            props?.getScheduleInstructorDetailsData
          }
          getLmsCourseLessonSafetyCompeleted_Detail={
            props?.getLmsCourseLessonSafetyCompeleted_Detail
          }
          getLmsCourseLessonSafetyInCompeleted_Detail={
            props?.getLmsCourseLessonSafetyInCompeleted_Detail
          }
          typeselectdata={props?.typeselectdata}
          setTypeselectdata={props?.setTypeselectdata}
        />
      ) : props.page === "SubcontractorCompletedTraingings" ||
        props.page === "UsersWithMostSafetyMeetings" ? (
        <SubcontractorCompletedTraingings
          getMoretDetails={props.getMoretDetails}
          getLmsDashboardReportDetails={
            props.getLmsDashboardReportDetails?.data
          }
          apiData={props.apiData}
          getToolBoxTalkListResult={props.getToolBoxTalkListResult}
          userTRainingLoadin={props?.userTRainingLoadin}
          handleClear={props?.handleClear}
          pageType={props?.page}
          page={props.page}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Items;
